// Import Firebase functions
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFunctions, httpsCallable } from "firebase/functions";


/*export const testCompanyFunction = () => {
  exports.createCompany = onCall(async (data, context) => {
    if (!context.auth) {
      throw new HttpsError("unauthenticated", "You must be logged in to create a company.");
    }
  })
}*/
//import CryptoJS from "crypto-js";



// Your Firebase configuration (replace with your actual Firebase config)
const firebaseConfig = {
    apiKey: import.meta.env.VITE_API_KEY,
    authDomain: import.meta.env.VITE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_APP_ID,
    measurementId: import.meta.env.VITE_MEASUREMENT_ID
};

// Debug log to verify environment variables
/*console.log('Firebase Config:', {
    apiKey: import.meta.env.VITE_API_KEY,
    authDomain: import.meta.env.VITE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_APP_ID,
    measurementId: import.meta.env.VITE_MEASUREMENT_ID
});*/

// Add error handling for missing API key
if (!firebaseConfig.apiKey) {
    console.error('Firebase API key is missing. Please check your environment variables.');
    throw new Error('Firebase API key is missing');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);



  //https://firebase.google.com/docs/functions/callable?gen=2nd#web





// Initialize Firebase services
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);

// Export the Firebase app instance if needed
export default app;
